import styled from 'styled-components'
import { Centered } from '../../../../components'
import { colors } from '../../../../constants'

const Background = styled(Centered)`
    background: ${colors.greylightest};
    height: 100%;
    position: relative;
`

const Box = styled.div`
    margin: 0 20px;
    margin-bottom: 15px;
    overflow-y: auto;
    text-align: center;
    width: 100%;
    //border-bottom:1px solid ${colors.greylight}

`
const DropBox = styled.div`
    border-radius: 10px;
    margin: 20px;
    margin-top:0;
    margin-bottom: 10px;
    overflow-y: auto;
    text-align: center;

`
const MediaWrapper = styled.div`
    display:flex;
    flex-wrap:wrap;
`


const ScrollView = styled.div`
    display:flex;
    overflow-y:scroll;
    flex-direction:column;
    height: 47%;
    justify-content:space-between;
`

const MediaHeader = styled.div`
    color: ${colors.blue};
    font-size: 18px;
    font-weight: bold;
    padding: 15px 30px;
    text-transform: none;
`

const InputWrapperStyle = {
    'height':'140px',
    'display':'flex',
    'alignItems':'center',
    'justifyContent':'center',
    'borderRadius':'15px',
    'border': `0px dashed ${colors.greylight}`,
    'background':'none',
    'backgroundImage': `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='15' ry='15' stroke='rgb(197, 208, 221)' stroke-width='7' stroke-dasharray='13' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`
}

const FooterStyle = {
    'background':`${colors.blue}`,
    'display': 'flex',
    'justifyContent': 'flex-end',
    'padding': '23px 30px 15px',
    'border': 'none'
}

export { Background, Box,MediaWrapper,DropBox,InputWrapperStyle,ScrollView,MediaHeader,FooterStyle }
